import { makeAutoObservable, computed, runInAction } from 'mobx';
import type { OrgUser } from './types';

export class UserStore {
  users = new Map<string, OrgUser>();

  constructor() {
    makeAutoObservable(this, { all: computed });
  }

  get all(): OrgUser[] {
    const result: OrgUser[] = [];
    for (const u of this.users.values()) result.push(u);
    return result.sort((a, b) => (a.displayName < b.displayName ? -1 : 1));
  }

  getById(id: string): OrgUser | undefined {
    return this.users.get(id);
  }

  loadFromRecords(records: Record<string, unknown>[]): void {
    runInAction(() => {
      for (const r of records) this.users.set(r.id as string, r as unknown as OrgUser);
    });
  }

  removeFromMap(ids: string[]): void {
    runInAction(() => {
      for (const id of ids) this.users.delete(id);
    });
  }

  clear(): void { this.users.clear(); }
}
